import SettingAdd from "../common/SettingModal";
import {
  ColTitle,
  CopyCode,
  RowSpan, Script,
  Site,
  SubmitButton
} from "../../assets/GlobalStyles";
import React from "react";
import {useSetAtom} from "jotai/index";
import {modalController} from "../../store";
import {ModalBody, ModalFooter, ModalHeader} from "../modal/Modal";
import {BorderBox, PreviewSubmit, TitColor} from "../table/styles";

function ScriptComponent(props){
  const {title, cellProps} = props
  const setModal = useSetAtom(modalController)

  const handleClick = () => {
    setModal({
      isShow: true,
      width: 800,
      modalComponent: () => {
        return (
            <div>
              <ModalHeader title={'스크립트 보기'}/>
              <ModalBody>
                <RowSpan>
                  <ColTitle style={{paddingTop: 10}}>픽셀명</ColTitle>
                  <BorderBox>{cellProps.data.eventName}</BorderBox>
                </RowSpan>
                <RowSpan>
                  <ColTitle style={{paddingTop: 10}}>
                    <p style={{whiteSpace: 'nowrap'}}>스크립트</p>
                    <SubmitButton onClick={() => handleCopyClipBoard(cellProps.data.script)} style={{width: '100%', marginTop: 8, padding: '5px 0'}}>
                      복사
                    </SubmitButton>
                  </ColTitle>
                  <BorderBox>
                    <pre>{cellProps.data.script}</pre>
                  </BorderBox>
                </RowSpan>
              </ModalBody>
              <ModalFooter>
                <PreviewSubmit onClick={() => setModal({isShow: false, modalComponent: null, reRender: false})}>확인</PreviewSubmit>
              </ModalFooter>
            </div>
        )
      }
    })
  }

  return(
      <>
        {title !== undefined ?
            <TitColor onClick={e => {
              e.stopPropagation()
              handleClick()
            }}>{title}
              <Script />
            </TitColor>
            :
            <Script onClick={e => {
              e.stopPropagation()
              handleClick()
            }}/>
        }
      </>
  )
}

const handleCopyClipBoard = async (text) => {
  if(navigator.clipboard){
    navigator.clipboard
    .writeText(text)
    .then(()=>{alert('클립보드에 복사되었습니다.')})
    .catch(()=>{alert('복사에 실패하였습니다.')});
  } else {
    if (!document.queryCommandSupported("copy")) {
      return alert("복사하기가 지원되지 않는 브라우저입니다.");
    }

    // 흐름 3.
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.position = "fixed";

    // 흐름 4.
    document.body.appendChild(textarea);
    // focus() -> 사파리 브라우저 서포팅
    textarea.focus();
    // select() -> 사용자가 입력한 내용을 영역을 설정할 때 필요
    textarea.select();
    // 흐름 5.
    document.execCommand("copy");
    // 흐름 6.
    document.body.removeChild(textarea);
    alert("클립보드에 복사되었습니다.");
  }
};

export default function Icon(props) {
  return(
      <>
        {props.saveType === 'edit' &&
            <SettingAdd data={props.cellProps} saveType={props.saveType} label={props.label} onSubmit={props.onSubmit}/>
        }
        {props.icon === 'script' &&
            <ScriptComponent cellProps={props.cellProps} title={props.title}/>
        }
        {props.icon === 'url' &&
            <a href={props.value} target={'_blank'} rel="noreferrer">
              <Site/>
            </a>
        }
        {props.icon === 'copyCode' &&
            <CopyCode onClick={() => handleCopyClipBoard(props.value)}/>
        }
      </>
  )
}